import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { Planner } from "../components/web-app-calendar";
import { page, PageEvents } from "../util/analytics.util";

const PlannerPage = () => {
  useEffect(() => {
    page(PageEvents.PLANNER);
  }, []);

  return (
    <>
      <Helmet>
        <title>Planner · Clockwise</title>
      </Helmet>
      <div className="cw-min-w-[280px] cw-bg-default cw-w-full cw-h-full cw-flex cw-flex-col cw-items-center">
        <Planner />
      </div>
    </>
  );
};

export default PlannerPage;
